// Customizable Area Start
import React from "react";
import { createStyles, Theme } from "@material-ui/core/styles";
import { withStyles, Box, Typography, Button } from "@material-ui/core";
import { AfterSignupModalSteps } from "./enums";

const configJSON = require("./config.js");

type Props = {
  classes: any;
  socialPhoneNumber: string;
  setStep: (step: AfterSignupModalSteps) => void;
};

export const AfterSignupNumber = ({ classes, socialPhoneNumber, setStep }: Props) => {
  const handleNextStep = () => {
    setStep(AfterSignupModalSteps.PROFILE_PICTURE);
  };

  return (
    <Box className={classes.container} id="phoneNumberScreen">
      <Typography className={classes.title}>
        The power of social texting at your fingertips.
      </Typography>
      <Box className={classes.numberContent}>
      <Box className={classes.messageContainer}>
        <Typography>{configJSON.numberText_1}</Typography>
        <Typography>{configJSON.numberText_2}</Typography>
      </Box>
      <Typography className={classes.phoneNumber}>
        {socialPhoneNumber}
      </Typography>
      <Typography style={{ fontWeight: 700 }}>
        {configJSON.numberTextBold}
      </Typography>
      </Box>
      <Button id="goToUploadButton" className={classes.buttonNext} onClick={handleNextStep}>
        Next
      </Button>
    </Box>
  );
};

const styles = (theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "35px",
      color: "#0F172A",
      overflow: "auto",

      "&::-webkit-scrollbar": {
        width: "10px",
      },

      "&::-webkit-scrollbar-track": {
        visibility: "hidden",
      },

      "&::-webkit-scrollbar-thumb": {
        background: "#D9D9D9",
      },
    },

    title: {
      fontSize: "24px",
      fontWeight: 700,
      [theme.breakpoints.down(768)]: {
        fontSize: "20px",
      },
    },

    numberContent: {
      display: "flex",
      flexDirection: "column",
      flexShrink: 1,
      paddingRight: "23px",
      gap: "20px",
      overflowY: "auto",

      "&::-webkit-scrollbar": {
        width: "6px",
        borderRadius: "39px",
      },

      "&::-webkit-scrollbar-track": {
        visibility: "hidden",
      },

      "&::-webkit-scrollbar-thumb": {
        background: "#D9D9D9",
      },

    },

    messageContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",

      "& *": {
        fontSize: "16px",
      }
    },

    phoneNumber: {
      fontSize: "50px",
      fontWeight: 700,
      [theme.breakpoints.down(768)]: {
        fontSize: "30px"
      },
    },

    buttonNext: {
      alignSelf: "flex-end",
      width: "253px",
      height: "56px",
      borderRadius: "8px",
      textTransform: "none",
      backgroundColor: "#FFC629",
      fontSize: "16px",
      fontWeight: 700,
      "&:hover" : {
        backgroundColor: "#0F172A",
        color: "#fff"
      },
      [theme.breakpoints.down(520)]: {
        width: "100%"
      },
    },
  });

export default withStyles(styles)(AfterSignupNumber);
// Customizable Area End
